import React from 'react';
import { Person, SliceLayoutComponent, SliceLayoutComponentProps } from '@shapeable/types';
import { createSliceLayout, SliceContentProps, useActivePerson, useAuth, usePageEntity } from '@shapeable/ui';
import { SliceContactEmail } from '../entities/slice-contact-email';

const SliceLayoutContactEmailImpl = createSliceLayout<SliceContentProps>(
  SliceContactEmail, {
    verticalPadding: 'slim',
    boundary: 'none',
  }
);

export const SliceLayoutContactEmail: SliceLayoutComponent = (props: SliceLayoutComponentProps) => {
  const pageEntity = usePageEntity() as Person;
  const { isAuthenticated } = useAuth() || {};
  const { person } = useActivePerson();
  const isOwnProfile = person?.slug === pageEntity?.slug;
  const hasEmail = !!pageEntity?.email && isAuthenticated && (!pageEntity?.hideEmail || isOwnProfile);

  if (!hasEmail) {
    return null;
  }

  return <SliceLayoutContactEmailImpl {...props} />;
};
